/** Routes that render outside the main app shell (no navbar/sidebar). */
export function isStandaloneRoute(pathname: string): boolean {
    return (
        pathname === "/sign-in" ||
        pathname.startsWith("/share/") ||
        pathname.startsWith("/reset-password/") ||
        pathname === "/Authentication" ||
        pathname === "/Authentication-App" ||
        pathname === "/modify-communication-settings" ||
        pathname === "/external-notification-preferences" ||
        pathname === "/oauth2/callback"
    );
}

export const standalonePathFromHash = (hash: string): string => {
    const raw = hash.replace(/^#/, "") || "/";
    return raw.split("?")[0] || "/";
};

export const isStandaloneRouteFromHash = (hash: string): boolean =>
    isStandaloneRoute(standalonePathFromHash(hash));
